export enum ProviderType {
  Jicoo = 0,
  Google = 10,
  Microsoft = 20,
  Apple = 30,
}

export const providerTypeName = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Jicoo:
      return 'Jicoo';
    case ProviderType.Google:
      return 'Google';
    case ProviderType.Microsoft:
      return 'Microsoft';
    case ProviderType.Apple:
      return 'Apple';
  }
};

export const providerTypeIconPath = (providerType: ProviderType) => {
  switch (providerType) {
    case ProviderType.Jicoo:
      return 'logo/symbol.svg';
    case ProviderType.Google:
      return 'account/google.svg';
    case ProviderType.Microsoft:
      return 'account/microsoft.svg';
    case ProviderType.Apple:
      return 'account/apple.svg';
  }
};
